import { Stack, Typography } from '@mui/joy';
import { Info } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine, Tooltip } from 'core/elements';
import { AgGridDataRow } from 'core/types';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList/enums';
import { Color, Direction, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  isAlternateVersionEnabled?: boolean;
  isRowEditable?: ({ data }: { data: AgGridDataRow }) => boolean;
}

export const VendorCell = ({
  isAlternateVersionEnabled = false,
  isRowEditable,
  ...rest
}: IProps) => {
  const { t } = useTranslation();

  const isGroupedByColumn = QuotePartColId.VENDOR === rest?.node?.rowGroupColumn?.getColId();

  const data = getAgGridTableCellData(rest, QuotePartColId.VENDOR);

  if (!data || isGroupedByColumn) {
    return <TextLine text={rest.value} textEllipsis />;
  }

  const isEditable = isRowEditable({ data });

  const { companyManufacturerName, companyManufacturerId, accountsPayableId } = data;

  const vendorId = isAlternateVersionEnabled ? accountsPayableId : companyManufacturerId;

  return (
    <Tooltip
      title={
        isEditable ? t('titleVendorInfoTooltipEditable') : t('titleVendorInfoTooltipNonEditable')
      }
      color={Color.PRIMARY}
    >
      <Stack sx={{ cursor: 'pointer' }}>
        <TextLine
          text={companyManufacturerName || DEFAULT_PLACEHOLDER}
          sx={{ cursor: 'pointer' }}
        />

        <TextLine
          text={vendorId || DEFAULT_PLACEHOLDER}
          endDecorator={
            <Typography level={Level.BODY_SM} color={Color.PRIMARY}>
              <Info style={{ height: '100%' }} />
            </Typography>
          }
          sx={{ flexDirection: Direction.ROW, cursor: 'pointer' }}
          isSubText
        />
      </Stack>
    </Tooltip>
  );
};
